export const caseStudy = [
  { value: '支援利用前', selected: false },
  { value: '支援利用時', selected: false },
  { value: '支援利用後', selected: false }
];
export const jobHunting = ['概要', '対象者', 'お問合せ・お申込み', '内容', '定員', '開催会場', '受講料', '地図で見る', '自由入力'];
export const skillSupport = [
  '入校時期',
  '対象',
  '授業料',
  '訓練実施施設',
  '内容',
  '主な就職先',
  '期間',
  '定員',
  '取得できる資格など',
  '自由入力',
  '地図で見る'
];
export const caseStudyItemTitle = [
  '当時の悩み',
  '支援メニューの利用詳細',
  '利用後・就職先の活躍',
  'アドバイス',
  '「支援メニュー名●●」の概要説明'
];
